import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { HttpClientService } from './http-client.service';
import type {
  EmailSendClient,
  SendEmailRequest,
  SendEmailResponse,
} from '../tokens/email-send-client.token';
import { EMAIL } from '../../shared/constants/api-routes.constants';

@Injectable({ providedIn: 'root' })
export class EmailSendService implements EmailSendClient {
  private readonly http = inject(HttpClientService);

  send(payload: SendEmailRequest): Observable<SendEmailResponse> {
    return this.http.post<SendEmailResponse>(EMAIL.SEND(), payload);
  }
}
